import React from 'react'

const Humanrights = () => {
  return (
    <div>
      <div>
        <h3>Working with words</h3>
        <p className='question'>A. Pair the following words as opposites.</p>
        <p>Despair: hope</p>
        <p>Kind: cruel</p>
        <p>Fresh: stale</p>
        <p>Strange: Familiar</p>
        <p>Normal: eccentric</p>
        <p>Fierce: gentle</p>
        <p>Corrupt: honest</p>
        <p>Selfish: generous</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. By adding a suitable suffix to each word in the table, form another word as in the examples below.</p>
        <p>Noun forms</p>
        <p>open-minded = open-mindedness</p>
        <p>accommodate = accommodation</p>
        <p>rehearse = rehearsal</p>
        <p>transgress = transgression</p>
        <p>angry = anger</p>
        <p>mix = mixture</p>
        <p>Adjective forms</p>
        <p>pain = painful</p>
        <p>differ = different</p>
        <p>behavior = well-behaved or behavioral</p>
        <p>remark = remarkable</p>
        <p>indifference = indifferent</p>
        <p>thought = thoughtful</p>
        <p>Verb forms</p>
        <p>less = lessen</p>
        <p>sure = ensure</p>
        <p>real = realize</p>
        <p>glory = glorify</p>
        <p>power = empower</p>
        <p>prison = imprison</p>
      </div>
      <div>
        <hr/>
        <h3>Comprehension</h3>
        <p className='question'>A. Write True or False after each statement. Give a reason for your answer</p>
        <p>a. The author says his father was an ideal person in the family.</p><p>
False</p><p>
Reason: He used to abuse his mother </p><p>verbally and physically when he was drunk.</p>
        <p>b. The author wanted to forgive his father but he did not get an opportunity.</p><p>
True </p><p>
Reason: He had many pressures and </p><p>stresses, and his father died before he could forgive him.</p>
        <p>c. It's worth forgiving a person if he/she realizes his/her mistakes.</p><p>
True</p>
        <p>d. South Africa had the dual type of education system in the 1960s.</p><p>
True</p>
        <p>e. The author lived in a joint family.</p><p>
False</p><p>
Reason: He lived with only his wife and two children.</p>
        <p>f. The author regretted not getting a chance to talk to his father.</p><p>
True</p>
<p>g. According to the author, all our glories and splendours are short-lived.
True</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Answer the following questions.</p>
        <p className='question'>a. How does the author remember his family environment when he was a small boy?</p>
        <p>= The author remembers his family environment as painful and abusive. He recalls that his father used to verbally and physically abuse his mother.</p>

        <p className='question'>b. Why does the author blame the system more than his father?</p>
        <p>= The author blames the system more than his father because the system caused his father's stress, pressure, and trauma, which led to his abusive behavior.</p>

        <p className='question'>c. How does the principle of forgiveness work?</p>
        <p>= The principle of forgiveness does not depend on the actions of others. It is a way of self-healing that brings peace and harmony to ourselves. Forgiveness helps release our pain and creates a sense of freedom in our heart and mind. People forgive not to help others, but for their own well-being, making forgiveness a kind of self-care or selfish act.</p>

        <p className='question'>d. How does the author interpret the noise, squalls and tantrums of his children?</p>
        <p>= The author interprets the noise, squalls, and tantrums of his children as a reflection of the many failures, irritations, and fatigue that parents experience.</p>

        <p className='question'>e. Why did the author decide to educate his children in Swaziland?</p>
        <p>= The author decided to educate his children in Swaziland because he was unhappy with the poor quality of education provided to black children under South Africa's Bantu Education Act.</p>

        <p className='question'>f. How does the author define human life?</p>
        <p>= According to the author, human life is a complex mix of goodness, beauty, cruelty, heartbreak, challenges, love, and many other emotions and experiences.</p>

        <p className='question'>g. According to the author, is it heredity or environment that shapes a man's character? Explain.</p>
        <p>= According to the author, it is the environment, not heredity, that shapes a person's character. Every child is born pure and innocent, neither a liar nor violent by nature. No one is born with hatred or less goodness than others. Therefore, heredity does not determine a person's character; rather, it is the surrounding environment and experiences that shape who we become.</p>

        <p className='question'>h. Why is forgiveness important in our life?</p>
        <p>= Forgiveness is important because it allows us to free ourselves from the pain and burden of past mistakes and wrongdoings. By forgiving, we can move forward in life without being held back by anger or regret. It helps us find peace and emotional healing, enabling us to live healthier and happier lives.</p>
      </div>
      <div>
        <hr/>
        <h3>Critical thinking</h3>
        <p className='question'>a. Desmond Tutu once said, "Forgiving is not forgetting; it is actually remembering-remembering and not using your right to hit back. It's a second chance for a new beginning." Does this quotation apply to this text? Analyze.</p>
        <p>= The quote by Desmond Tutu means that forgiveness does not mean forgetting the harm done to us. Instead, it means remembering the pain but choosing not to seek revenge. Forgiveness gives us a chance to start fresh.
</p><p>
In the text, the author experiences domestic violence from his father and feels the pain deeply. As a child, he wanted to hurt his father back. However, as he grows older, he learns to forgive his father, understanding that his father's abusive behavior was caused by the pressures and mistreatment faced by black people under South Africa's oppressive system.
</p><p>
Thus, the author's forgiveness is not about forgetting the pain but about remembering it without retaliating. This perfectly reflects Desmond Tutu's idea that forgiveness is a second chance for a new beginning.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. The author interprets "I am sorry" as the three hardest words to say. How does it apply to your life?</p>
        <p>= Committing mistakes is a part of human life, but accepting those mistakes and apologizing for them is often the hardest task. In the text, the author describes “I am sorry” as the three hardest words to say. This ties closely with the concept of empathy, which means putting ourselves in others' shoes and understanding their feelings. Empathy requires humility. Too often, we are consumed by our own emotions and forget that others matter too. By sincerely saying "I am sorry," we acknowledge the other person's pain and validate their feelings.
</p><p>
In my own life, I also find these three words difficult to say, especially when I've hurt someone. Instead of apologizing, I tend to distance myself from the person I've hurt and wait for them to come and talk to me first. I am a sensitive and proud person, and I get hurt easily. When someone hurts me, I expect them to approach me and say sorry, but I rarely consider how much my actions may have affected others.
</p><p>
Saying “I am sorry” makes me feel uneasy. My pride, fear of being ashamed, emotional sensitivity, and even a sense of superiority sometimes stop me from apologizing. I struggle with the overwhelming emotions of guilt and the lack of awareness about the other person's pain. These feelings and internal conflicts make it very difficult for me to say those three powerful words, I am sorry.</p>
      </div>
      <div>
        <hr/>
        <h3>Writing</h3>
        <p className='question'>The author talks about the dual education system based on race in South Africa in the second half of the twentieth century. We also have private schools and public schools in Nepal. What should be done to make education equal for all citizens of Nepal? Write a couple of paragraphs expressing your views.</p>
        <p>= Nepal has made significant progress in promoting equity in education, but much still needs to be done to ensure that every citizen has equal access to quality learning opportunities. Historically, education in Nepal was reserved for the elite, and it wasn't until the 1950s that the general population began to gain access to schools. Although there have been improvements, issues such as income disparity, gender inequality, language barriers, disability, and geographic isolation continue to affect educational access and outcomes. Public schools in rural areas often lack basic facilities such as clean drinking water, proper sanitation, and adequate classroom resources. These challenges, along with child malnutrition and poor living conditions, hinder students' ability to focus and perform well, increasing dropout rates.
</p><p>
To make education more equal for all citizens of Nepal, both private and public schools should be strengthened and supported with proper infrastructure, trained teachers, and modern teaching materials, including the use of technology. The government should invest more in rural education, ensuring that children in remote areas receive the same quality of education as those in urban settings. Special attention must be given to marginalized communities affected by caste, ethnicity, gender, and poverty. Scholarship programs, awareness campaigns, and inclusive policies should be expanded and strictly implemented to close the gap between different social groups. Only through equal opportunities and inclusive policies can Nepal build an education system that serves all its citizens fairly and effectively.</p>
      </div>
      <div>
        <hr/>
        <h3>Grammar</h3>
        <p className='question'>A. Join the following pairs of sentences using when and while</p>
        <p>a. Bibha Kumari was doing her homework. The doorbell rang</p>
        <p>= Bibha Kumari was doing her homework when the doorbell rang.</p>
        <p>= While Bibha Kumari was doing her homework, the doorbell rang.</p>
        <br/>
        <p>b. I heard the telephone ring. I picked it up.</p>
        <p>= I picked it up when I heard the telephone ring. </p>
        <p>= While I was picking up the telephone, it rang.</p>
        <br/>
        <p>c. Dil Maya found a thousand rupee note. She was washing her pants.</p>
        <p>= Dil Maya found a thousand rupee note while she was washing her pants.</p>
        <p>= Dil Maya found a thousand rupee note when she was washing her pants.</p>
        <br/>
        <p>d. Tenjing gave his measurements to the dressmaker. He was visiting the market yesterday.</p>
        <p>= Tenjing gave his measurements to the dressmaker when he was visiting the market yesterday.</p>
        <p>= While Tenjing was visiting the market yesterday, he gave his measurements to the dressmaker.</p>
        <br/>
        <p>e. I was at the butcher's shop. I met Harikala.</p>
        <p>= I met Harikala when I was at the butcher's shop.</p>
        <p>= While I was at the butcher's shop, I met Harikala.</p>
        <br/>
        <p>f. The sales agent was dealing with the customer. A thief stole the jewels.</p>
        <p>= The sales agent was dealing with the customer while a thief stole the jewels.</p>
        <p>= A thief stole the jewels when the sales agent was dealing with the customer.</p>
        <br/>
        <p>g. My small brother was sleeping. I played chess with my father.</p>
        <p>= My small brother was sleeping while I played chess with my father.</p>
        <p>= I played chess with my father when my small brother was sleeping.</p>
        <br/>
        <p>h. The old lady fell down. She was climbing up the stairs.</p>
        <p>= The old lady fell down while she was climbing up the stairs.</p>
        <p>= The old lady fell down when she was climbing up the stairs.</p>
        <br/>
        <p>i. The leader was giving a speech loudly. He lost his voice.</p>
        <p>= The leader lost his voice while he was giving a speech loudly.</p>
        <p>= The leader lost his voice when he was giving a speech loudly.</p>
        <br/>
        <p>j. Kanchan broke her backbone. She was lifting up the load.</p>
        <p>= Kanchan broke her backbone while she was lifting up the load.</p>
        <p>= Kanchan broke her backbone when she was lifting up the load.</p>
   
      </div>
      <hr/>
      <div>
        <p className='question'>B. Fill in the blanks with one of the connectives from the box.</p>
        <p>a. We didnt go for a morning walk today <strong>since</strong> it was raining.</p>
        <p>b. I wanted to go home early <strong>as</strong> I was not feeling well.</p>
        <p>c. My brother stayed at home <strong>because of/owing to</strong> his illness.</p>
        <p>d. I was late in the class <strong>owing to</strong> traffic jams.</p>
        <p>e. He didn't like dogs <strong>so</strong> he was not happy when his wife brought a puppy at home.</p>
        <p>f. He was not included in the team <strong>owing to</strong> his knee injury.</p>
        <p>g. <strong>As</strong> I was tired, I went to bed early</p>
        <p>h. He was very unhappy <strong>since</strong> he lost one million rupees in share market.</p>
        <p>i. We cancelled our trip to Rara Lake <strong>owing to</strong> the bad weather.</p>
        <p>j. These two lines intersect with each <strong>because</strong> they are are not parallel lines.</p>
      </div>
    </div>
  )
}

export default Humanrights
